import { useQuery } from '@tanstack/react-query'
import { CourseGroupEntity } from '../../../qourses-api-client'
import { qoursesApi } from '../../api/qourses.tsx'

export default function useGetCourseGroup(courseGroupId: string): {
  courseGroup: CourseGroupEntity
  isLoading: boolean
  isError: boolean
  refetch: () => void
  isRefetching: boolean
} {
  const {
    data: courseGroup,
    isLoading,
    isError,
    refetch,
    isRefetching,
  } = useQuery(getCourseGroupQueryKey(courseGroupId), async () => {
    return qoursesApi.courseGroup.courseGroupControllerGetCourseGroupV1(courseGroupId)
  })

  return { courseGroup, isLoading, isError, refetch, isRefetching }
}

export const getCourseGroupQueryKey = (courseGroupId: string) => ['courseGroup', courseGroupId]
